export default {
    props: {
        iconClass: {
            type: String,
            default: undefined,
            kComposite: 'iconClass'
        },
        name: {
            type: String,
            default: undefined,
            kComposite: 'name'
        },
        template: {
            type: [String, Function],
            default: undefined,
            kComposite: 'template'
        },
        text: {
            type: String,
            default: undefined,
            kComposite: 'text'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGridToolbar/Toolbar.js